import { Controller } from "@hotwired/stimulus";
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class extends Controller {
    static targets = [
        'swiper',
        'thumbs',
        'prevButton',
        'nextButton',
    ];

    get prevButton() {
        return this.hasPrevButtonTarget ? this.prevButtonTarget : null;
    }

    get nextButton() {
        return this.hasNextButtonTarget ? this.nextButtonTarget : null;
    }


    swiper;

    connect() {
        const target = this.hasSwiperTarget ? this.swiperTarget : this.element;

        if (target) {
            this.swiper = new Swiper(target, {
                ...this.options,
            });
        }
    }

    disconnect() {
        this.swiper?.destroy();
        this.swiper = null;
    }

    get options() {
        const prevButton = this.prevButton || '.swiper-button-prev';
        const nextButton = this.nextButton || '.swiper-button-next';

        const options = {
            preloadImages:       false,
            watchSlidesProgress: true,
            loop:                true,
            spaceBetween:        10,

            lazy: {
                loadPrevNext:          false,
                loadOnTransitionStart: true,
            },

            navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
            },
        };

        const thumbsTarget = this.hasThumbsTarget ? this.thumbsTarget : null;
        if (thumbsTarget) {
            const thumbs = new Swiper(thumbsTarget, {
                spaceBetween:        10,
                slidesPerView:       6,
                freeMode:            true,
                watchSlidesProgress: true,
            });

            options.thumbs = {
                swiper: thumbs,
            };
        }

        return options;
    }
}
